export const FORMAT_SLUG = 'amp/tooltip-format';
export const TITLE = 'Tooltip';

export const TOOLTIP_KEY = 'tooltip';
export const TOOLTIP_ATTRIBUTE_NAME = 'data-tooltip';

export const TOOLTIP_TRIGGER_CLASS_NAME = 'amp-tooltip';
export const TOOLTIP_JS_ENABLED_BODY_CLASS_NAME = 'amp-tooltip-js-enabled';
export const TOOLTIP_PORTAL_CLASS_NAME = 'amp-tooltip-portal';
export const TOOLTIP_PORTAL_CONTENT_CLASS_NAME = 'amp-tooltip-portal__content';
export const TOOLTIP_PORTAL_TEXT_CLASS_NAME = 'amp-tooltip-portal__text';
export const TOOLTIP_PORTAL_ARROW_CLASS_NAME = 'amp-tooltip-portal__arrow';
export const TOOLTIP_VISIBLE_CLASS_NAME = 'is-visible';
